export default __webpack_public_path__ + "static/david-3e397fd8cfb1cca08e27e9d33e85eaea.jpg";